module.exports = __webpack_public_path__ + "img/ENGINEERING_BG_pattern.29da960a.svg";